export default function ButtonSecondary({ text, action, onClick, disabled = false }) {
    const handleClick = () => {
        if (!disabled && onClick) {
            onClick(action);
        }
    };

    return (
        <button onClick={handleClick} disabled={disabled} className="bg-white border-2 border-solid border-main text-main py-2 px-4 rounded-xl transition-all duration-300 ease-in-out hover:bg-main hover:text-white">
            {text}
        </button>
    );
}
